import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero, Perspective, About, Staged, Listings, Consultations, HomeFeels } from "../components/km/Sections";
import Reviews from "../components/km/Reviews";
import AsSeenIn from "../components/km/AsSeenIn";
import BuyerGuide from "../components/km/BuyerGuide";
import CultureTeaser from "../components/km/Culture";
import BuilderTeaser from "../components/km/BuilderTeaser";

export default function HomePage({ onConnect }) {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" }), 150);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <main>
      <Hero onConnect={onConnect} />
      <Perspective />
      <About onConnect={onConnect} />
      <Staged />
      <AsSeenIn />
      <Listings />
      <Reviews />
      <Consultations onConnect={onConnect} />
      <BuilderTeaser />
      <BuyerGuide />
      <HomeFeels onConnect={onConnect} />
      <CultureTeaser />
    </main>
  );
}
